import { Fragment, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useForgotPassword } from '@/hooks/ForgotPassword/useForgotPassword';

import { useStyle } from '@/classify';
import FormErrors from '../FormError';
import ForgotPasswordForm from './ForgotPasswordForm';
import forgotPasswordOperations from './forgotPassword.gql';

import defaultClasses from './forgotPassword.module.css';

const ForgotPassword = props => {
  const { initialValues, onCancel = () => {}, setIsShowBorder, isShowBack } = props;

  const { formatMessage } = useIntl();
  const talonProps = useForgotPassword({
    onCancel,
    ...forgotPasswordOperations,
  });

  const {
    forgotPasswordEmail,
    formErrors,
    handleCancel,
    handleFormSubmit,
    hasCompleted,
    isResettingPassword,
    recaptchaWidgetProps,
  } = talonProps;

  const classes = useStyle(defaultClasses, props.classes);
  const INSTRUCTIONS = formatMessage({
    id: 'forgotPassword.instructionText',
    defaultMessage: 'Please enter your email address below to receive a password reset link.',
  });

  useEffect(() => {
    if (!setIsShowBorder) {
      return;
    }

    setIsShowBorder(hasCompleted);
  }, [hasCompleted, setIsShowBorder]);

  return (
    <div className='personalContent mx-auto px-[12px] py-[40px] lg_px-0 lg_pb-[80px] lg_pt-[60px]'>
      <Fragment>
        <h2 className='mb-[10px] text-left font-teko-medium text-[28px] uppercase leading-[28px] text-primary lg_mb-0 lg_text-[40px] lg_leading-[48px]'>
          <FormattedMessage
            id={'forgotPassword.forgotPasswordText'}
            defaultMessage={'Reset your password'}
          />
        </h2>
        <p className='mb-[20px] text-left font-roboto-regular text-[16px] leading-[24px] text-primary lg_mb-[60px] lg_text-[18px] lg_leading-[30px]'>
          {INSTRUCTIONS}
        </p>
        <ForgotPasswordForm
          initialValues={initialValues}
          isResettingPassword={isResettingPassword}
          onSubmit={handleFormSubmit}
          onCancel={handleCancel}
          recaptchaWidgetProps={recaptchaWidgetProps}
          hasCompleted={hasCompleted}
          isShowBack={isShowBack}
        />
        <FormErrors errors={formErrors} />
      </Fragment>
    </div>
  );
};

export default ForgotPassword;
